import { Component, OnInit } from '@angular/core';
import { DatePipe, NgForOf, NgIf } from "@angular/common";
import { Router } from '@angular/router';
import { RandomDataService } from "../../services/random-data.service";
import { ApiService } from "../../services/api.service";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, firstValueFrom, map } from "rxjs";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { AnagraficaPage, Asl, AslAbruzzo } from "../../model/model";
import { JsonPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { NgbDatepickerModule, NgbDateStruct, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from "../../../environments/environment";
import { SharedFormService } from '../../services/shared-form.service';
import {OAuthService} from "angular-oauth2-oidc";
import { ToastService } from '../../services/toast.service';
import { AuthService } from '../../services/auth-service.service';

@Component({
  selector: 'app-mortem-ricerca-anagrafica',
  standalone: true,
  imports: [
    NgIf, ReactiveFormsModule, FormsModule, NgbDatepickerModule, JsonPipe, NgForOf, DatePipe, NgbTypeaheadModule
  ],
  templateUrl: './mortem-ricerca-anagrafica.component.html',
  styleUrl: './mortem-ricerca-anagrafica.component.scss'
})
export class MortemRicercaAnagraficaComponent implements OnInit {
  isLoading = false;
  @BlockUI() blockUI!: NgBlockUI;

  pagina: number = 0;
  righeXPagina: number = 10;
  sortBy: string = "id";
  sortDirection: string = "DESC";
  paginaAnagrafica: AnagraficaPage | undefined;
  paginaFiltrata: any = [];
  utente: any;

  form = this.sharedFormService.form;
  formFiltro = this.sharedFormService.form.get('filtro') as FormGroup;

  nome:string|undefined
  cognome:string|undefined
  codiceFiscale:string|undefined
  dataNascita:any
  dataMorte:any
  asl:string|undefined

  modificaAbilitata: boolean = false;
  operatoreRegione: boolean = false;

  aslSubscription: any;

  aslAbruzzo: any = [];
  aslAbruzzoString: any = [];

  dataOdierna: Date = new Date();

  constructor(private router: Router, private formBuilder: FormBuilder, private rds: RandomDataService, private api: ApiService,
    private sharedFormService: SharedFormService, private oauthService: OAuthService, private toastService: ToastService,
    private authService: AuthService) { }

      searchAslAbruzzo: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
        text$.pipe(
          debounceTime(200),
          distinctUntilChanged(),
          map((term) =>
            term.length < 2 ? [] : this.aslAbruzzoString.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
          ),
        )

  async ngOnInit() {
    this.utente = await firstValueFrom(this.api.getUtente()).finally(this.blockUI.stop);

    this.aslSubscription = this.formFiltro.get('asl')?.valueChanges.subscribe(() => {
      let aslValue = this.formFiltro.get('asl')?.value
      if(aslValue != undefined){
        let firstThree = aslValue.substring(0,3);
        this.formFiltro.get('asl')?.setValue(firstThree); 
      }
    })

    this.aslAbruzzo = await firstValueFrom(this.api.getAslAbruzzo());
    this.aslAbruzzo = this.aslAbruzzo.content;
    this.aslAbruzzoString = Array.from(new Set(this.aslAbruzzo.map((asl: AslAbruzzo) => asl.asl)));
    

    const flusso = this.authService.getCheckEnableToFlusso(this.utente);
    const operatori = this.authService.getCheckEnableOperatore(this.utente);
    this.operatoreRegione = this.authService.getCheckEnableOperatoreRegione(this.utente);
    if(!flusso) {
      this.oauthService.logOut();
      this.toastService.showError("Utente non autorizzato");
    }
    if(operatori){
      this.modificaAbilitata = true;
    }
    else{
      this.modificaAbilitata = false;
    }
    await this.loadTableData();
    await this.attivaFiltroECarica();
  }

  async ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.aslSubscription){
      this.aslSubscription.unsubscribe();
    }
  }

  async loadTableData() {
    this.blockUI.start("Caricamento dati in corso");
    this.paginaAnagrafica = await firstValueFrom(this.api.getAnagrafichePaginate(this.pagina, this.righeXPagina, this.sortBy, this.sortDirection, this.nome, this.cognome, this.codiceFiscale, this.dataNascita,this.dataMorte, this.asl)).finally(() => this.blockUI.stop());
  }

  async goToSchedaMorteModifica(id: number | undefined) {
    let url: string = "/scheda-morte/" + id
    this.router.navigateByUrl(url);
  }

  async goToSchedaMorteNuova() {
    this.router.navigate(['scheda-morte']);
  }

  async attivaFiltroECarica() {
    await this.filtraAnagrafica();
    await this.loadTableData();

  }

  async filtraAnagrafica() {
    this.nome = this.formFiltro.get('nome')?.value !== null ? this.formFiltro.get('nome')?.value.toUpperCase() : undefined;
    this.cognome = this.formFiltro.get('cognome')?.value !== null ? this.formFiltro.get('cognome')?.value.toUpperCase() : undefined;
    this.codiceFiscale = this.formFiltro.get('codiceFiscale')?.value !== null ? this.formFiltro.get('codiceFiscale')?.value.toUpperCase() : undefined;
    this.dataNascita = this.formFiltro.get('dataNascita')?.value !== null ? this.formFiltro.get('dataNascita')?.value : undefined;
    this.dataMorte = this.formFiltro.get('dataMorte')?.value !== null ? this.formFiltro.get('dataMorte')?.value : undefined;
    this.asl = this.formFiltro.get('asl')?.value !== null ? this.formFiltro.get('asl')?.value : undefined;
  }

  async cancellaFiltro() {
    this.formFiltro.reset();
    await this.attivaFiltroECarica();
    //await this.filtraAnagrafica();
    //await this.loadTableData();
  }

  async creaSchedaTest() {
    this.blockUI.start("Creazione scheda di test in corso");
    let ana = this.rds.generateRandomAnagraficaDto();
    ana.datiParteAS = this.rds.generateRandomDatiParteA();
    ana.datiParteBS = this.rds.generateRandomDatiParteB();
    firstValueFrom(this.api.getComuni());
    firstValueFrom(this.api.getStati());
    firstValueFrom(this.api.getDizionari());
    let result = await firstValueFrom(this.api.saveOrUpdateAnagrafica(ana)).finally(() => this.blockUI.stop());
    this.loadTableData();
  }

  onDateSelect(data: NgbDateStruct, form: string) {
    if (data) {
      const dataSelezionata = new Date(data.year, data.month - 1, data.day);
      this.formFiltro.get(form)?.setValue(dataSelezionata);
    }
  }

  maxLengthInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const isBackspace = event.key === 'Backspace';
    const isTab = event.key === 'Tab';

    if (input.value.length === maxLength && !isBackspace && !isTab) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  numberOfPages(totalPages: number | undefined) {
    return Array(totalPages).fill(0); // Crea un array di lunghezza n
  }

  cambiaPagina(p: number) {
    this.pagina = p;
    this.loadTableData();
  }

  protected readonly environment = environment;

  sortByAndGo(valore: string) {
    this.sortBy=valore;
    this.loadTableData();
  }
}
